import React from "react";
import { useState } from "react";
import { SiBitcoinsv } from "react-icons/si";
import { SiEthereum } from "react-icons/si";
import { MdMonetizationOn } from "react-icons/md";
import { TbArrowsExchange } from "react-icons/tb";
import {SiBinance} from "react-icons/si";


const Tab = () => {
  const [activeTab, setActiveTab] = useState("buy");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="  ">
      <div className="flex flex-row ">
        <button
          className={`${
            activeTab === "buy"
              ? "bg-slate-600 text-white"
              : "bg-gray-300 text-gray-700"
          } flex-1 py-2 sm:rounded-tl-lg sm:rounded-bl-lg mb-2`}
          onClick={() => handleTabClick("buy")}
        >
          Buy
        </button>
        {/* <button
          className={`${
            activeTab === "sell"
              ? "bg-slate-600 text-white"
              : "bg-gray-300 text-gray-700"
          } flex-1 py-2 sm:rounded-tr-lg sm:rounded-br-lg w-auto mb-2`}
          onClick={() => handleTabClick("sell")}
        >
          Sell
        </button> */}
      </div>
      {activeTab === "buy" && (
        <div className="bg-slate-100 rounded-lg text-center  p-8   ">
          <div className="lg:grid lg:grid-cols-4  gap-2  ">
            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <SiBitcoinsv size={60} color="orange" />
              </center>
              <h1 className="text-3xl p-4 tracking-wider pt-4 ">Bitcoin</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3 bg-white">
              <center className="pt-8">
                {" "}
                <SiEthereum size={60} color="blue" />
              </center>
              <h1 className="text-3xl p-4 tracking-wider  pt-4 ">Ethereum</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <MdMonetizationOn size={60} color="green" />
              </center>
              <h1 className="text-3xl p-4  tracking-wider pt-4 ">USD</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <SiBinance size={60} color="yellow" />
              </center>
              <h1 className="text-3xl p-4  tracking-wider pt-4 ">BNB</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>
          </div>
          <h1 className="text-center mt-6 lg:mt-12 mb-8 lg:mb-4 lg:text-3xl">
            Amount
          </h1>
          <div className="lg:grid lg:grid-cols-2 grid grid-cols-1 gap-4 ">
            <input
              type="text"
              name="price"
              id="price"
              class="block w-sm rounded-lg border-0 py-1.5 pl-8 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-400 sm:text-sm sm:leading-6"
              placeholder="0.00 GBP"
            />
            <input
              type="text"
              name="price"
              id="price"
              class="block w-sm rounded-lg border-0 py-1.5 pl-8 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-400 sm:text-sm sm:leading-6 "
              placeholder="0.00 BTC"
            />
          </div>
          <div className=" flex justify-center gap-8 py-6">
            <button className=" hover:bg-slate-600 hover:text-white border rounded-full lg:py-2 lg:px-8 px-6 py-2 bg-white w-fit text-xs lg:text-lg ">
              {" "}
              Cancel
            </button>
            <div className="hidden">
              {" "}
              <TbArrowsExchange size={44} color="gray" />
            </div>
            <button className=" hover:bg-slate-600 hover:text-white border rounded-full lg:py-2 lg:px-8 px-6 py-2  bg-white w-fit text-xs lg:text-lg">
              {" "}
              Buy Now
            </button>
          </div>
        </div>
      )}
      {/* {activeTab === "sell" && (
        <div className="bg-slate-100 rounded-lg text-center  p-8   ">
          <div className="lg:grid lg:grid-cols-4  gap-2  ">
            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <SiBitcoinsv size={60} color="orange" />
              </center>
              <h1 className="text-3xl p-4 tracking-wider pt-4 ">Bitcoin</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3 bg-white">
              <center className="pt-8">
                {" "}
                <SiEthereum size={60} color="blue" />
              </center>
              <h1 className="text-3xl p-4 tracking-wider  pt-4 ">Ehereum</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <MdMonetizationOn size={60} color="green" />
              </center>
              <h1 className="text-3xl p-4  tracking-wider pt-4 ">USD</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>

            <div className=" border border-slate-800 rounded mt-3  bg-white">
              <center className="pt-8">
                {" "}
                <SiBinance size={60} color="green" />
              </center>
              <h1 className="text-3xl p-4  tracking-wider pt-4 ">BNB</h1>
              <p className="pb-6"> 5,486 BTC</p>
            </div>
          </div>
          <h1 className="text-center mt-6 lg:mt-12 mb-8 lg:mb-4 lg:text-3xl">
            Amount
          </h1>
          <div className="lg:grid lg:grid-cols-2 grid grid-cols-1 gap-4 ">
            <input
              type="text"
              name="price"
              id="price"
              class="block w-sm rounded-lg border-0 py-1.5 pl-8 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-400 sm:text-sm sm:leading-6"
              placeholder="0.00 GBP"
            />
            <input
              type="text"
              name="price"
              id="price"
              class="block w-sm rounded-lg border-0 py-1.5 pl-8 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-slate-400 sm:text-sm sm:leading-6 "
              placeholder="0.00 BTC"
            />
          </div>
          <div className=" flex justify-center gap-8 py-6">
            <button className=" hover:bg-slate-600 hover:text-white border rounded-full lg:py-2 lg:px-8 px-6 py-2 bg-white w-fit text-xs lg:text-lg ">
              {" "}
              Cancel
            </button>
            <div className="hidden">
              {" "}
              <TbArrowsExchange size={44} color="gray" />
            </div>
            <button className=" hover:bg-slate-600 hover:text-white border rounded-full lg:py-2 lg:px-8 px-6 py-2  bg-white w-fit text-xs lg:text-lg">
              {" "}
              Sell Now
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Tab;
